import { render } from "./MaintenanceWindowAlert.vue?vue&type=template&id=680f356b"
import script from "./MaintenanceWindowAlert.vue?vue&type=script&lang=js"
export * from "./MaintenanceWindowAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__